export default {

	thumbnail: function(src, options) {

		options = options || ['fullpath']

		if (src) {

			var parts = src.split('/')

			var domain = parts.slice(0, 3).join('/')
			var path = parts.slice(3).join('/')

			path = path.replace('.png', '').replace('.jpg', '')

			return 'url(' + domain + '/thumb/480/480/' + options.join(',') + '/' + path + ')'

		} else {

			return false

		}

	}

}